module.exports = __webpack_public_path__ + "img/22.0e9525c8.jpg";